import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

export enum DepositFrequency {
  SINGLE = 'SINGLE',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  REPEAT_EVERY = 'REPEAT_EVERY',
  EMPTY = '',
}

export enum DepositType {
  SINGLE = 'single',
  REGULAR = 'regular',
  EMPLOYER = 'employer',
  GOVERNMENT = 'government',
  FUTURE = 'FUTURE',
  FUTURE_SINGLE = 'SINGLE',
  FUTURE_REGULAR = 'REGULAR',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  REPEAT_EVERY = 'REPEAT_EVERY',
  LAST = 'LAST',
  EMPTY = '',
}

export interface Deposit {
  id?: string;
  type: DepositType;
  title?: string;
  value?: AmountValue;
  frequency?: DepositFrequency;
  repeatYears?: string;
  since?: string;
  until?: string;
  active?: boolean;
  date?: string;
  elapsed?: number;
  // FIXME: interface
  inflation?: { enabled: boolean; rate: number, valuation: boolean; type: string; }
}

export interface DepositOptions {
  frequency: string[];
  frequencyEmployer: string[];
  inflationType: string[];
  maxPeriodicUntil: string;
  minYears: number;
  maxYears: number;
  maxDate: string;
}

export interface DepositsData {
  //single: AmountValue; // FIXME: deprecated
  //regular: AmountValue; // FIXME: deprecated
  //regularUntil: string; // FIXME: deprecated
  initial?: {
    active: boolean;
    value: AmountValue;
  }
  periodic?: {
    active: boolean;
    value: AmountValue;
    inflation?: { enabled: boolean; rate: number; valuation: boolean; type: string; }
    until: string;
  }
  employer?: Deposit;
  employerAllowed: boolean;
  deposits: Deposit[];
  options: DepositOptions;
  lastPayment?: {
    date: string;
    value: AmountValue;
    elapsed: number;
  };
  //inflation?: { enabled: boolean; rate: number; valuation: boolean; type: string; }  // FIXME: deprecated
}

// TODO: use initialValues instead of hidden input?
export const getInitialValues = (currency: Currency): Deposit => ({
  value: { value: 0, currency: currency },
  until: undefined,
  type: DepositType.EMPTY,
  frequency: DepositFrequency.EMPTY,
  inflation: { enabled: false, rate: 0, valuation: false, type: ''}
});
